import React, { useState } from "react";
import { FiSearch } from "react-icons/fi";

export default function GroupChatSearch({
  search = "",
  fetchGroups,
  fetchAllUser,
  createNewGroupSection,
}) {
  const [timeoutId, setTimeoutId] = useState(null);

  const handleSearch = (e) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    setTimeoutId(
      setTimeout(() => {
        const searchQuery = e.target.value;
        if (createNewGroupSection === 1) {
          fetchAllUser(1, searchQuery.trim());
        }
        if (createNewGroupSection === 0) {
          fetchGroups(true, 1, searchQuery.trim()); // Fetch channels with the search query
        }
      }, 300)
    );
  };

  return (
    <div className="relative w-full">
      <FiSearch className="absolute left-5 top-1/2 transform -translate-y-1/2 text-zinc-400 text-lg z-10" />
      <input
        defaultValue={search}
        onKeyDown={(e) => handleSearch(e)}
        type="text"
        placeholder={`Search ${createNewGroupSection == 1 ? "Member" : "Group"}`}
        className="w-full bg-white dark:bg-slate-800 border-none shadow-md rounded-full pl-12 pr-5 py-3 text-sm text-zinc-700 dark:text-zinc-200 focus:ring-2 focus:ring-indigo-500/20 focus:outline-none placeholder:text-zinc-400 transition-all"
      />
    </div>
  );
}
